import type { CandidateVacancy } from '../types';

type CandidateActivitySphere = NonNullable<
  CandidateVacancy['activitySpheres']
>[number];

export function mockCandidateActivitySphere(
  overrides: Partial<CandidateActivitySphere> = {}
): CandidateActivitySphere {
  return {
    id: '1',
    name: 'Software development',
    slug: 'software-development',
    code: '6201',
    ...overrides,
  };
}
